
import { ValidateStringInput } from "../directives/validate-string-input.function";

export enum SourceViews {
  List = 'List',
  Grid = 'Symbols'
}
